export const AWS_WAF_CAPTCHA_TRIGGER = 'aws-waf-captcha-trigger';
